import * as actionTypes from './actionTypes';

export const initConnectivity = () => {
  console.log('did this actions start')

  return {
    type: actionTypes.INIT_CONNECTIVITY
  };
};

export const initConnectivityStart = () => {
  return {
    type: actionTypes.INIT_CONNECTIVITY_START
  };
};

export const setConnectivity = (connectivity) => {
  return {
    type: actionTypes.SET_CONNECTIVITY,
    connectivity:connectivity
  };
};

export const fetchConnectivityFailed = () => {
  return {
    type: actionTypes.FETCH_CONNECTIVITY_FAILED
  };
};

export const initGetSpectrumStatus = () => {
  return {
    type: actionTypes.INIT_SPECTRUM_STATUS
  };
};

export const initGetSpectrumStatusStart = () => {
  return {
    type: actionTypes.INIT_SPECTRUM_STATUS_START
  };
};

export const setSpectrumStatus = (payload) => {
  return {
    type: actionTypes.SET_SPECTRUM_STATUS,
    payload
  };
};

export const getSpectrumStatusFailed = () => {
  return {
    type: actionTypes.GET_SPECTRUM_STATUS_FAILED
  };
};

export const moveIn = () => {
  return {
    type: actionTypes.MOVE_IN
  }
}
export const moveOut = () => {
  return {
    type: actionTypes.MOVE_OUT
  }
}
export const showSideMenu = () => {
  return {
    type: actionTypes.SHOW_SIDE_MENU
  }
}
export const dontShowSideMenu = () => {
  return {
    type: actionTypes.DONT_SHOW_SIDE_MENU
  }
}
